<div class="periods-container">
  <nz-radio-group
    [(ngModel)]="tempModel.multiPeriod"
    class="toggle-single-or-multi-period"
    (ngModelChange)="handleModelChanges()"
  >
    <label class="bold-text" nz-radio [nzValue]="false"
      >View a Single Period</label
    >
    <span class="normal-text radio-desc"
      >See broker detail on individual line items for a particular period</span
    >
    <label class="bold-text" nz-radio [nzValue]="true"
      >View Multiple Periods</label
    >
  </nz-radio-group>

  <div class="horizontal-divider"></div>

  <div class="select-group-container">
    <span class="bold-text">Show</span><br />
    <select
      id="ptype"
      [(ngModel)]="tempModel.periodType"
      (ngModelChange)="handleModelChanges()"
    >
      <option value="A">Annuals Only</option>
      <option value="I">Interims Only</option>
      <option value="AI">Annuals and Interims</option>
    </select>

    <select
      id="interimtype"
      *ngIf="tempModel.multiPeriod === false && tempModel.periodType === 'I'"
      [(ngModel)]="tempModel.interimType"
      (ngModelChange)="handleModelChanges()"
    >
      <ng-container *ngFor="let interim of interimsList">
        <option [value]="interim">{{ interim }}</option>
      </ng-container>
    </select>

    <select
      id="periodstart"
      [(ngModel)]="tempModel.selectedFrom"
      (ngModelChange)="handleModelChanges($event)"
    >
      <ng-container *ngFor="let yearItem of yearList">
        <option [ngValue]="yearItem.year">{{ yearItem.label }}</option>
      </ng-container>
    </select>

    <select
      id="periodend"
      *ngIf="tempModel.multiPeriod === true"
      [(ngModel)]="tempModel.selectedTo"
      (ngModelChange)="handleModelChanges($event)"
    >
      <ng-container *ngFor="let yearItem of yearList">
        <option [ngValue]="yearItem.year">{{ yearItem.label }}</option>
      </ng-container>
    </select>
  </div>
  <span class="normal-text"
    >Available: {{ originalModel.from }} to {{ originalModel.to }}</span
  >

  <div class="actions">
    <button
      [disabled]="actionsDisabled"
      nz-button
      nzType="default"
      nzSize="small"
      (click)="handleCancel()"
    >
      Cancel
    </button>
    <button
      id="options-refresh-buttons-apply-periods"
      [disabled]="actionsDisabled"
      nz-button
      nzType="primary"
      nzSize="small"
      (click)="handleApply($event)"
    >
      Apply
    </button>
  </div>
</div>
